import { gqlFetcher } from '#features/api';
import { graphql } from '#features/api/utils/graphql';
import { isDefined } from '#utils/isDefined';

const lastVisitsDoc = graphql(`
  query LastVisits($ids: [UUID]!) {
    user {
      lastVisits(userIds: $ids) {
        userId
        lastVisit
      }
    }
  }
`);

export const getLastVisits = (ids: string[]) =>
  gqlFetcher(lastVisitsDoc, { ids }).then((data) => data.user.lastVisits?.filter(isDefined));
